import type { LocaleDictionary } from "@/i18n/types";

const nsSheetJA = {
  fallbackName: "シート",
  row: {
    downloadCSV: "ダウンロード（CSV）",
    downloadReferencedCSV: "参照先のデータをダウンロード（CSV）",
    uploadCSV: "アップロード（CSV）",
    uploadTadsData: "アップロード（CSV/JSON）",
    downloadTadsJSON: "ダウンロード（JSON）",
    uploadOverwrite: "上書き",
    uploadAppend: "追加",
    duplicate: "シートを複製",
    delete: "シートを削除",
  },
  menu: {
    create: "シートを作成",
    downloadExcel: "Excel形式でデータを一括ダウンロード",
    downloadJSON: "JSON形式でデータを一括ダウンロード",
    downloadYAML: "YAML形式でシート設定ファイルを一括ダウンロード",
    uploadData: "データを一括アップロード",
    openList: "シート一覧を開く",
  },
  dataDownload: {
    inProgress: "データのダウンロードを実行中...",
    success: "データのダウンロードに成功しました",
    error: "データのダウンロードに失敗しました",
  },
  schemaDownload: {
    inProgress: "シート設定ファイルの一括ダウンロードを実行中...",
    success: "シート設定ファイルの一括ダウンロードに成功しました",
    error: "シート設定ファイルの一括ダウンロードに失敗しました",
  },
  csv: {
    invalidSheetError: "シートデータが不適切のため、ダウンロードできません",
    downloadSuccess: "ダウンロードに成功しました",
    downloadError: "ダウンロード中にエラーが発生しました",
    noFileError: "ファイルが選択されていません",
    uploadSuccess: "CSVデータのアップロードが完了しました",
    uploadError: "CSVデータのアップロードに失敗しました",
  },
  tadsReplaceDialog: {
    title: "時間累積データシートの範囲置換",
    message: ({ fileName, window }: { fileName: string; window: string }) =>
      `${window} の既存の行をすべて削除し、${fileName} の内容に置き換えます。`,
    unresolvableWindow:
      "シートの参照できる期間を解決できないため置換できません。シート設定の「参照できる範囲」から期間を直してください。",
    button: "置き換える",
    inProgressButton: "置き換え中...",
    inProgressTitle: "行を置き換えています...",
    success: ({ importedRows }: { importedRows: number }) =>
      `${importedRows} 行に置き換えました`,
    error: "行の置き換えに失敗しました",
  },
  tadsAppend: {
    inProgressTitle: "行を追加しています...",
    unsupportedFile: "CSV または JSON ファイルを選択してください",
    unresolvableWindow:
      "シートの参照できる期間を解決できないため追加できません。シート設定の「参照できる範囲」から期間を直してください。",
    success: ({ importedRows }: { importedRows: number }) =>
      `${importedRows} 行を追加しました`,
    error: "行の追加に失敗しました",
  },
  referencedSheetsCheckError: "シート参照のチェックに失敗しました",
  duplicate: {
    inProgress: "シートを複製中...",
    success: "シートを複製しました",
    error: "シートを複製できませんでした",
  },
  uploadDialog: {
    title: "シートデータアップロード（Excel, CSV, JSON）",
    button: "一括更新",
    description: "データを更新します。",
    selectFile: "更新用のデータファイルを選択してください。",
    connectCSV: "CSVデータとシートの紐付けを行なってください。",
    saveTypeLabel: "データアップロード方法",
    saveTypeOverwrite: "上書き",
    saveTypeAppend: "追加",
    noteExcel:
      "Excelファイルに含まれないシート、および参照シートは変更されません",
    noteJSON:
      "JSONファイルに含まれないシート、および参照シートは変更されません",
    noteCSV: "CSVの場合は、選択したシート以外は変更されません",
    inProgressTitle: "データをアップロードしています",
    csvInProgressTitle: "CSVデータをアップロードしています",
  },
  deleteDialog: {
    title: "シートの削除",
    message: ({ sheetName }: { sheetName: string }) =>
      `${sheetName} を削除します。削除したシートは元に戻せません。`,
    referencedWarning:
      "他のシートから参照されているシートのため、表示が破壊されることがあります。",
    button: "削除",
    inProgressButton: "削除中...",
    success: "シートを削除しました",
    error: "シートを削除できませんでした",
  },
} satisfies LocaleDictionary;

export default nsSheetJA;
